require('normalize.css/normalize.css');
require('../../css/blog/index.scss');


import { navigatePro } from '../utils.js';
import { Loader } from '@googlemaps/js-api-loader';

const loader = new Loader({
  apiKey: 'AIzaSyDPRMuc-vQprevDs0T98KYsk2Wj_ytM0gM',
  libraries: ['places'],
  region: 'us',
});

loader
  .load()
  .then(() => {
    const input = document.getElementById('location_search');
    const options = {
      componentRestrictions: { country: ['us'] },
      types: ['geocode'],
    };
    const autocomplete = new google.maps.places.Autocomplete(input, options);
    google.maps.event.addListener(autocomplete, 'place_changed', () => {
      const category = document.getElementById('pro_category').value;
      
      const place = autocomplete.getPlace();
      const search = place.formatted_address;
      let city; let
        state;

      place.address_components.forEach((component) => {
        if (component.types.includes('sublocality') || component.types.includes('locality')) {
          city = component.short_name;
        }
        if (component.types.includes('administrative_area_level_1')) {
          state = component.short_name;
        }

        navigatePro(search, state, city, category);
      });
    });
  })
  .catch((e) => {
    console.log(e);
  });